import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseTabInterface } from '../../../shared/interfaces/base-tab.interface';
import { BaseButtonSize, BaseButtonSizeType } from '../../../shared/components/button/base-button.component';
import { Router } from '@angular/router';

@Component({
  selector: 'base-horizontal-nav',
  templateUrl: './base-horizontal-nav.component.html',
})
export class BaseHorizontalNavComponent<T extends BaseTabInterface> {
  @Input() tabs: Array<T> = [];
  @Input() tabClass: string;
  @Input() tabSize: BaseButtonSizeType = BaseButtonSize.md;
  @Input() isCombined = false;
  @Input() current: T;
  @Output() tabChange = new EventEmitter<T>();

  buttonSizes = BaseButtonSize;

  constructor(private router: Router) {}

  onTabSelect(tab: T): void {
    if (this.current.id === tab.id) {
      return;
    }

    if (tab.url) {
      this.router.navigate([tab.url]).then(() => {
        this.setCurrentTab(tab);
      });
    } else {
      this.setCurrentTab(tab);
    }
  }

  setCurrentTab(tab: T): void {
    this.tabChange.emit(tab);
  }

  trackByTab(_: number, tab: T) {
    return tab.id;
  }
}
